import jumpToDownload from './jumpToDownload';
import { downloadUrl } from "@/constant/download";

const removeWakeupTimer = () => {
  let timer = (window as any).wakeupAppTimer;
  if (timer) {
    clearTimeout((window as any).wakeupAppTimer);
    (window as any).wakeupAppTimer = null;
  }
};

const wakeupApp = () => {
  const t = 2000;
  const body = document.body;
  location.href = downloadUrl.scheme;
  removeWakeupTimer();

  (window as any).wakeupAppTimer = setTimeout(() => {
    const hide = document.hidden;
    if (!hide) {
      jumpToDownload();
    }
  }, t);

  body.addEventListener("visibilitychange", removeWakeupTimer);
  body.addEventListener("webkitvisibilitychange", removeWakeupTimer);
  window.addEventListener("pagehide", removeWakeupTimer);
};

export default wakeupApp;
